import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/use-auth'
import { useNavigate } from 'react-router-dom'

export function AccessDenied({
  title = 'Access denied',
  message = 'Your account does not have access to this area.',
}: {
  title?: string
  message?: string
}) {
  const navigate = useNavigate()
  const { logout, isLoggingOut } = useAuth()

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/login', { replace: true })
    } catch {
      // The global session banner explains that secure logout did not complete.
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted/20 px-6">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>
        <Button className="mt-6" variant="outline" disabled={isLoggingOut} onClick={handleLogout}>
          {isLoggingOut ? 'Signing out…' : 'Sign out and use another account'}
        </Button>
      </div>
    </main>
  )
}
